import { API_ROUTES_FOR_AXIOS } from 'src/constants/ApiRoutes';
import { FILE_PICK_STATUS } from 'src/constants/filePick';
import { axiosInstance } from 'src/constants/axiosInstance';
import { ApiResponse, PaginatedResponse } from 'src/types/commonResponseTypes';
import { handleError } from 'src/utils/commonErrorUtils';

export interface FilePickPayload {
  file_id: string;
  name: string;
  url: string;
  status?: FILE_PICK_STATUS;
}

export interface FilePickRecord {
  _id: string;
  file_id: string;
  name: string;
  url: string;
  uploaded_on: string;
  status: FILE_PICK_STATUS;
}

export const createFilePick = async (
  body: FilePickPayload,
): Promise<ApiResponse<FilePickRecord>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS.createFilePick();
    const { data } = await axiosInstance.post(apiUrl, body);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getFilePicks = async (
  page: number,
  limit: number,
  filterType?: 'self' | 'org',
): Promise<ApiResponse<PaginatedResponse<FilePickRecord[]>>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS.getFilePicks();
    const params: Record<string, any> = { page, limit };

    if (filterType) {
      params.filterType = filterType;
    }

    const { data } = await axiosInstance.get(apiUrl, { params });

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const revokeFilePick = async (
  chunkBatchId: string,
): Promise<ApiResponse<null>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS.revokeFilePick(chunkBatchId);
    const { data } = await axiosInstance.patch(apiUrl, { chunkBatchId });

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export interface UpdateFilePickStatusPayload {
  chunkBatchId: string;
  status: FILE_PICK_STATUS;
}

export const updateFilePickStatus = async (
  payload: UpdateFilePickStatusPayload,
): Promise<ApiResponse<FilePickRecord>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS.updateFilePickStatus(
      payload.chunkBatchId,
    );
    const { data } = await axiosInstance.patch(apiUrl, payload);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
